import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onBeforeMount, ref } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useHistoryItemDescResize } from '@/composables/format-edit/useShokurekishoHistoryItem'
import type { ShokurekishoImageItem } from '@/composables/format-edit/useShokurekishoFormatData'
import ShokurekishoImageUploadFields from '@/components/format-edit/shokurekisho/ShokurekishoImageUploadFields.vue'

type FormLibWithCharCount = {
  charCount: (value: unknown) => number
}

type ElFormLike = {
  validate: () => Promise<unknown>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageItem',
  props: {
    item: null,
    index: null,
    length: null,
    descriptionPlaceholder: null,
    descriptionMaxLength: null,
    minYear: null,
    maxYear: null,
    activeImageItem: null
  },
  emits: ["add-history-item", "delete-history-item", "move-history-item"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'add-history-item', index: number, item?: ShokurekishoImageItem): void
  (e: 'delete-history-item', index: number): void
  (e: 'move-history-item', params: { index: number; to: string }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: ShokurekishoImageItem
  index: number
  length: number
  descriptionPlaceholder?: string
  descriptionMaxLength?: number
  minYear?: number | string
  maxYear?: number | string
  activeImageItem?: string
};





const { formLib } = useHostServices()
const formLibChars = formLib as typeof formLib & FormLibWithCharCount
const historyItemForm = ref<ElFormLike | null>(null)
const { desc } = useHistoryItemDescResize()

const editableItem = computed(() => props.item)
const isActive = computed(() => props.activeImageItem === props.item.uuid)

function charTooLong(value: unknown, max: number) {
  return formLibChars.charCount(value) > max
}

const rules = {
  description: [
    {
      validator: (
        _rule: unknown,
        value: unknown,
        callback: (err?: Error) => void
      ) => {
        if (charTooLong(value, props.descriptionMaxLength || 0)) {
          callback(new Error('Please input digits'))
        } else callback()
      },
      message:
        '一行におさまる文字数をオーバーしています。文章を短くするか、行を ＋ で追加して入力してください。',
      trigger: ['change', 'blur']
    }
  ]
}

function handleCommand(command: string) {
  if (command === 'addAbove') emit('add-history-item', props.index)
  else if (command === 'addBelow') emit('add-history-item', props.index + 1)
  else if (command === 'delete') emit('delete-history-item', props.index)
  else if (command === 'duplicate') {
    emit('add-history-item', props.index, props.item)
  } else if (command === 'moveUp') {
    emit('move-history-item', { index: props.index, to: 'up' })
  } else if (command === 'moveDown') {
    emit('move-history-item', { index: props.index, to: 'down' })
  }
}

function deactivateImageItem() {
  emitter.emit('deactivate-image-item')
}

onBeforeMount(() => {
  nextTick(() => {
    if (!historyItemForm.value) return
    historyItemForm.value
      .validate()
      .then()
      .catch(() => {})
  })
})

return { __sfc: true,props, emit, formLib, formLibChars, historyItemForm, desc, editableItem, isActive, charTooLong, rules, handleCommand, deactivateImageItem, ShokurekishoImageUploadFields }
}

})